export default __webpack_public_path__ + "static/media/3.08238b5e.jpg";